import { UseMutationResult } from '@tanstack/react-query';

import { getRespondedOnTimeReportCsv, useBaseReportCsv } from 'api';

export const useRespondedOnTimeReportCsv = (): UseMutationResult<Blob> =>
  useBaseReportCsv(getRespondedOnTimeReportCsv);
